/**
 * Ecran plein qui empeche la caisse de demarrer, avec ce qu'il faut faire.
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { palette } from './theme';

export default function BlockingScreen({ title, lines = [], actionLabel, onAction, testId }) {
    return (
        <Box
            role="alert"
            data-testid={testId}
            sx={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: 3, p: 4, textAlign: 'center', bgcolor: palette.errorTint, color: palette.errorOnTint,
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 96 }} aria-hidden="true" />
            <Typography component="h1" sx={{ fontSize: 36, fontWeight: 800 }}>{title}</Typography>
            {lines.map((line) => (
                <Typography key={line} sx={{ fontSize: 22, maxWidth: 820 }}>{line}</Typography>
            ))}
            {actionLabel && onAction && (
                <Button variant="contained" size="large" onClick={onAction} sx={{ minHeight: 88, px: 6 }}>
                    {actionLabel}
                </Button>
            )}
        </Box>
    );
}
